import { useEffect, useState } from "react";

import { deviceSizes } from "./constants";
import { SizeContext } from "./sizeContext";
import type { UseThemeType } from "./types";

const sizesFromWidth = (width: number): UseThemeType["sizes"] => {
  const isMobile = width < deviceSizes.tablet;
  const isTablet = width >= deviceSizes.tablet;
  const isComputer = width >= deviceSizes.laptop;
  const isLargeComputer = width >= deviceSizes.laptopL;
  return {
    isMobile,
    isTablet,
    isComputer,
    isLargeComputer,
    width,
    minStyle: Object.entries(deviceSizes).reduce(
      (curr, [key, val]) => ({ ...curr, [key]: `min-width: ${val}px;` }),
      {},
    ),
    maxStyle: Object.entries(deviceSizes).reduce(
      (curr, [key, val]) => ({ ...curr, [key]: `max-width: ${val}px;` }),
      {},
    ),
  };
};

export const SizeProvider = ({ children }: { children: React.ReactNode }) => {
  const { innerWidth } = window;
  const [sizes, setSizes] = useState(sizesFromWidth(innerWidth));

  useEffect(() => {
    let timeout: number | null = null;
    const updateDimensions = () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(() => {
        const { innerWidth: currentInnerWidth } = window;
        setSizes(sizesFromWidth(currentInnerWidth));
      }, 50);
    };

    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  return <SizeContext.Provider value={sizes}>{children}</SizeContext.Provider>;
};
